import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    propertyData: {
        propertyDetails: {}
    },
    documentupload: {
        frontPagePhoto: {},
        backPagePhoto: {},
        visaStampImage: {},
        immigrationImage: {},
        documentType: '',
    },
    roomCatgData: {
        roomCatgDataWithMeal: [],
        allServiceAndCharges: [],
    },
    navigation: {
        homeNavigate: "",
    },
    signatureImagePath: '',
    reservationData: {},
    currentUser: {},
    existingBookingNo: 0,
    encodedStringData: '',
};

export const selfCheckinSlice = createSlice({
    name: "checkin",
    initialState: initialState,
    reducers: {
        clearAllData: (state) => {
            state.documentupload.frontPagePhoto = {};
            state.documentupload.backPagePhoto = {};
            state.documentupload.visaStampImage = {};
            state.documentupload.immigrationImage = {};
        },
        setPropertyDetails: (state, action) => {
            let data = action.payload;
            state.propertyDetails = data;
        },
        setReservationData: (state, action) => {
            let data = action.payload;
            state.reservationData = data;
        },
        setFrontPagePhoto: (state, action) => {
            let data = action.payload;
            state.documentupload.frontPagePhoto = data;
        },
        setBackPagePhoto: (state, action) => {
            let data = action.payload;
            state.documentupload.backPagePhoto = data;
        },
        setVisaStampImage: (state, action) => {
            let data = action.payload;
            state.documentupload.visaStampImage = data;
        },
        setImmigrationImage: (state, action) => {
            let data = action.payload;
            state.documentupload.immigrationImage = data;
        },
        setDocumentType: (state, action) => {
            let data = action.payload;
            state.documentupload.documentType = data;
        },
        setRoomCatgDataWithMeal: (state, action) => {
            let data = action.payload;
            state.roomCatgData.roomCatgDataWithMeal = data;
        },
        setAllServiceAndCharges: (state, action) => {
            let data = action.payload;
            state.roomCatgData.allServiceAndCharges = data;
        },
        setHomeNavigate: (state, action) => {
            let data = action.payload;
            state.navigation.homeNavigate = data;
        },
        setSignatureImagePath: (state, action) => {
            let data = action.payload;
            state.signatureImagePath = data;
        },
        setCurrentUser: (state, action) => {
            let data = action.payload;
            state.currentUser = data;
        },
        setExistingBookingNo: (state, action) => {
            let data = action.payload;
            state.existingBookingNo = data;
        },
        setEncodedDataString: (state, action) => {
            let data = action.payload;
            state.encodedStringData = data;
        },

    },
});

export const {
    setPropertyDetails, setReservationData, setFrontPagePhoto, setBackPagePhoto, setVisaStampImage, setImmigrationImage,
    clearAllData, setRoomCatgDataWithMeal, setAllServiceAndCharges, setHomeNavigate, setSignatureImagePath, setCurrentUser,
    setExistingBookingNo, setEncodedDataString, setDocumentType
} = selfCheckinSlice.actions;

export const propertyDetails = (state) => state.checkin.propertyDetails;
export const reservationData = (state) => state.checkin.reservationData;
export const documentupload = (state) => state.checkin.documentupload;
export const roomCatgData = (state) => state.checkin.roomCatgData;
export const navigation = (state) => state.checkin.navigation;
export const signatureImagePath = (state) => state.checkin.signatureImagePath;
export const currentUser = (state) => state.checkin.currentUser;
export const existingBookingNo = (state) => state.checkin.existingBookingNo;
export const encodedStringData = (state) => state.checkin.encodedStringData;
export const decodeStringData = (state) => state.checkin.decodeStringData;

export default selfCheckinSlice.reducer;